import React from 'react'
import { Col, Row, Button } from 'react-bootstrap'
import axios from 'axios'
import moment from 'moment'

export function deepValue(obj, path, pro){
  if (pro === 'program') {console.log("DEPPVALUE FUNCT", obj, path)}
        for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
            if(obj[path[i]]){
                obj = obj[path[i]];
            }
            else{
                return null;
            }
        };
        return obj;
    }


export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function getParams() {
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
        url = window.location.href,
        params = {},
        match;
    while (match = regex.exec(url)) {
        params[match[1]] = match[2];
    }
    return params
}

export function mmddyyDateFormat(dateString) {
    var date = new Date(dateString);
    return ("0" + (date.getMonth() + 1).toString()).substr(-2) + "/" + ("0" + date.getDate().toString()).substr(-2) + "/" + (date.getFullYear().toString()).substr(2);
}

export function mmddyyyyDateFormat(dateString) {
  var date = new Date(dateString);
  return ("0" + (date.getMonth() + 1).toString()).substr(-2) + "/" + ("0" + date.getDate().toString()).substr(-2) + "/" + (date.getFullYear().toString());
}

export function end_point(microservice){
  const envName = process.env.REACT_APP_IGENO_ENV ? process.env.REACT_APP_IGENO_ENV.toUpperCase() : 'PRODUCTION'
  const endPoint = microservice ? `REACT_APP_END_POINT_${microservice.toUpperCase()}_${envName}` : `REACT_APP_END_POINT_${envName}`
  const fallbackEndPoint = microservice ? `REACT_APP_END_POINT_${microservice.toUpperCase()}_PRODUCTION` : null
  return process.env[endPoint] || (fallbackEndPoint ? process.env[fallbackEndPoint] : undefined)
}

export function slugifyLinkAlias(alias) {
  return (alias || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export const PROGRAM_TYPE_BUCKETS = [
  'camp',
  'league',
  'club team',
  'skill session',
  'private',
]

const PROGRAM_TYPE_DEFAULT_LABELS = {
  camp: 'Camp',
  league: 'League',
  'club team': 'Club Team',
  'skill session': 'Skill Session',
  private: 'Private',
}

const PROGRAM_TYPE_ALIAS_MAP = {
  camp: 'camp',
  camps: 'camp',
  academy: 'camp',
  class: 'skill session',
  classes: 'skill session',
  league: 'league',
  'house league': 'league',
  houseleague: 'league',
  'internal league': 'league',
  internalleague: 'league',
  'rep league': 'league',
  tournament: 'league',
  'club team': 'club team',
  clubteam: 'club team',
  'club-team': 'club team',
  'skill session': 'skill session',
  skillsession: 'skill session',
  'skill-session': 'skill session',
  skill: 'skill session',
  skills: 'skill session',
  private: 'private',
  privates: 'private',
}

export const normalizeProgramTypeBucket = (type) => {
  const normalized = (type || '').toString().trim().toLowerCase()
  return PROGRAM_TYPE_ALIAS_MAP[normalized] || normalized
}

export const getProgramTypeBucketLabel = (bucket) => {
  const normalized = normalizeProgramTypeBucket(bucket)
  return PROGRAM_TYPE_DEFAULT_LABELS[normalized] || bucket
}

export const getDefaultProgramTypeLabels = () => (
  PROGRAM_TYPE_BUCKETS.map((bucket) => ({
    id: `default-${bucket}`,
    label: getProgramTypeBucketLabel(bucket),
    bucket,
    active: true,
    isDefault: true,
  }))
)

export const getProgramTypeOptions = (organizationProgramTypes = []) => {
  const seen = new Set()
  const options = []

  PROGRAM_TYPE_BUCKETS.forEach((bucket) => {
    const label = getProgramTypeBucketLabel(bucket)
    const key = `default-${bucket}`
    seen.add(label.toLowerCase())
    options.push({ key, value: label, label, bucket })
  })

  organizationProgramTypes.forEach((entry, index) => {
    if (!entry || entry.active === false) {
      return
    }

    const label = (entry.label || '').trim()
    const bucket = normalizeProgramTypeBucket(entry.bucket)
    if (!label) {
      return
    }

    const dedupeKey = label.toLowerCase()
    if (seen.has(dedupeKey)) {
      return
    }

    seen.add(dedupeKey)
    options.push({
      key: entry.key || `custom-${index}-${dedupeKey}`,
      value: label,
      label,
      bucket,
    })
  })

  return options
}

const PROGRAM_DETAILS_SECTION = `Program Details
Program Name: {{program_name}}
Ages: {{ages}}
Division: {{division}}
Start Date: {{program_start_date}}
End Date: {{program_end_date}}
Details: {{program_description}}
Additional Notes: {{additional_notes}}
Sessions: {{program_sessions}}
Virtual Sessions: {{virtual_sessions}}`

const ADMIN_ENROLMENT_DETAILS_SECTION = `Enrolment Details
Status: {{status_label}}
Club Name: {{organization_name}}
Program Name: {{program_name}}
Ages: {{program_ages}}
Division: {{program_division}}

Account Holder Details
Name: {{account_holder_name}}
Email: {{account_holder_email}}
Phone: {{account_holder_phone}}

Player Details
Name: {{player_name}}
Gender: {{player_gender}}
Birthday: {{player_birthday}}
Phone: {{player_phone}}
Email: {{player_email}}
Address: {{player_address}}
School: {{player_school}}
Notes From Parent: {{parent_notes}}

Secondary Contact Details
Name: {{secondary_contact_name}}
Phone: {{secondary_contact_phone}}
Email: {{secondary_contact_email}}`

const ADMIN_TRANSACTION_DETAILS_SECTION = `Transaction Details
Plan Name: {{plan_name}}
Plan Amount: {{plan_amount}}
Transaction Total: {{transaction_total}}
Payment Type: {{payment_type}}`

const EMAIL_TEMPLATE_DEFINITIONS = {
  parent_registration_confirmation: {
    key: 'parent_registration_confirmation',
    label: 'Parent Registration Confirmation',
    subject: 'Thank you for registering for {{program_name}}',
    body: `Dear {{parent_first_name}},<br/><br/>
Thank you for registering your team. Please review the details below.
${PROGRAM_DETAILS_SECTION}
Invoice Details
Plan Name: {{plan_name}}
Plan Amount: {{plan_amount}}
Transaction Total: {{transaction_total}}
<br/><br/>Login to your account <a href="${process.env.REACT_APP_HOOPSTIR_URL}/login?organization_id={{organization_id}}">here</a><br/><br/>
<h3 style="margin-bottom: 3px">Invite Your Friends</h3>      
Do you have friends that should register for this event?  Send them the link and they can register: ${process.env.REACT_APP_HOOPSTIR_URL}/login?organization_id={{organization_id}}
{{waiver_section}}`,
  },
  admin_registration_confirmation: {
    key: 'admin_registration_confirmation',
    label: 'Admin Registration Confirmation',
    subject: 'New Enrolment! {{program_name}}',
    body: `${ADMIN_ENROLMENT_DETAILS_SECTION}

${ADMIN_TRANSACTION_DETAILS_SECTION}`,
  },
  parent_waitlist_confirmation: {
    key: 'parent_waitlist_confirmation',
    label: 'Parent Waitlist Confirmation',
    subject: '{{program_name}} | Status: Waitlist',
    body: `Dear {{parent_first_name}},<br/><br/>
Welcome to the WAITLIST for the selected program. We will send invitations when a spot becomes available.
${PROGRAM_DETAILS_SECTION}
Invoice Details
Plan Name: {{plan_name}}
Plan Amount: {{plan_amount}}
Transaction Total: {{transaction_total}}
<br/><br/>Login to your account <a href="${process.env.REACT_APP_HOOPSTIR_URL}/login?organization_id={{organization_id}}">here</a><br/><br/>
<h3 style="margin-bottom: 3px">Invite Your Friends</h3>      
Do you have friends that should register for this event?  Send them the link and they can register: ${process.env.REACT_APP_HOOPSTIR_URL}/login?organization_id={{organization_id}}
{{waiver_section}}`,
  },
}

export const getDefaultEmailTemplates = () => JSON.parse(JSON.stringify(EMAIL_TEMPLATE_DEFINITIONS))

export const normalizeEmailTemplates = (templates = {}) => {
  const defaults = getDefaultEmailTemplates()
  return Object.keys(defaults).reduce((acc, key) => {
    const defaultTemplate = defaults[key]
    const incoming = templates[key] || {}
    let body = incoming.body !== undefined ? incoming.body : defaultTemplate.body
    body = body.replace(/<br\s*\/?>/gi, '\n')
    body = body.replace(/{{\s*program_details\s*}}/g, PROGRAM_DETAILS_SECTION)
    body = body.replace(/{{\s*enrolment_details\s*}}/g, ADMIN_ENROLMENT_DETAILS_SECTION)
    body = body.replace(/{{\s*transaction_details\s*}}/g, ADMIN_TRANSACTION_DETAILS_SECTION)
    body = body.replace(/{{\s*registration_intro\s*}}/g, 'Thank you for registering your team. Please review the details below.')
    body = body.replace(/{{\s*waitlist_intro\s*}}/g, 'Welcome to the WAITLIST for the selected program. We will send invitations when a spot becomes available.')
    acc[key] = {
      ...defaultTemplate,
      ...incoming,
      key,
      label: defaultTemplate.label,
      subject: incoming.subject !== undefined ? incoming.subject : defaultTemplate.subject,
      body,
      active: incoming.active !== false,
    }
    return acc
  }, {})
}

const DEFAULT_ORG_PRIMARY_COLOR = '#5563b8'
const DEFAULT_ORG_PRIMARY_TEXT_COLOR = '#ffffff'
const ORG_THEME_STORAGE_KEY = 'hoopstir.organizationTheme'

const normalizeHexColor = (color, fallback) => {
  if (typeof color !== 'string') {
    return fallback
  }

  const trimmed = color.trim()
  if (/^#[0-9a-fA-F]{6}$/.test(trimmed)) {
    return trimmed
  }

  if (/^#[0-9a-fA-F]{3}$/.test(trimmed)) {
    return `#${trimmed.slice(1).split('').map((char) => `${char}${char}`).join('')}`
  }

  return fallback
}

const shadeHexColor = (color, percent) => {
  const normalized = normalizeHexColor(color, DEFAULT_ORG_PRIMARY_COLOR).slice(1)
  const amount = Math.round(2.55 * percent)
  const numericColor = parseInt(normalized, 16)
  const red = Math.max(0, Math.min(255, (numericColor >> 16) + amount))
  const green = Math.max(0, Math.min(255, ((numericColor >> 8) & 0x00ff) + amount))
  const blue = Math.max(0, Math.min(255, (numericColor & 0x0000ff) + amount))
  return `#${((red << 16) | (green << 8) | blue).toString(16).padStart(6, '0')}`
}

const getContrastColor = (color) => {
  const normalized = normalizeHexColor(color, DEFAULT_ORG_PRIMARY_COLOR).slice(1)
  const red = parseInt(normalized.slice(0, 2), 16)
  const green = parseInt(normalized.slice(2, 4), 16)
  const blue = parseInt(normalized.slice(4, 6), 16)
  const luminance = (0.299 * red) + (0.587 * green) + (0.114 * blue)
  return luminance > 186 ? '#1f2430' : '#ffffff'
}

export function applyOrganizationTheme(theme = {}) {
  if (typeof document === 'undefined' || !document.documentElement) {
    return
  }

  const primaryColor = normalizeHexColor(theme.navbar_color, DEFAULT_ORG_PRIMARY_COLOR)
  const primaryTextColor = normalizeHexColor(
    theme.navbar_text_color,
    DEFAULT_ORG_PRIMARY_TEXT_COLOR
  )
  const root = document.documentElement.style

  root.setProperty('--org-primary-color', primaryColor)
  root.setProperty('--org-primary-hover-color', shadeHexColor(primaryColor, -10))
  root.setProperty('--org-primary-color-soft', shadeHexColor(primaryColor, 12))
  root.setProperty('--org-primary-color-deep', shadeHexColor(primaryColor, -18))
  root.setProperty('--org-primary-text-color', primaryTextColor)
  root.setProperty('--org-primary-contrast-color', getContrastColor(primaryColor))
  root.setProperty('--org-secondary-color', primaryTextColor)
  root.setProperty('--org-navbar-text-color', primaryTextColor)

  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(ORG_THEME_STORAGE_KEY, JSON.stringify({
        navbar_color: primaryColor,
        navbar_text_color: primaryTextColor,
      }))
    }
  } catch (err) {
    // Ignore storage failures; theme still applies for the current page.
  }
}

export function resetOrganizationTheme() {
  applyOrganizationTheme({
    navbar_color: DEFAULT_ORG_PRIMARY_COLOR,
    navbar_text_color: DEFAULT_ORG_PRIMARY_TEXT_COLOR,
  })
}

export function getStoredOrganizationTheme() {
  if (typeof localStorage === 'undefined') {
    return null
  }

  try {
    const rawTheme = localStorage.getItem(ORG_THEME_STORAGE_KEY)
    if (!rawTheme) {
      return null
    }

    const parsedTheme = JSON.parse(rawTheme)
    if (!parsedTheme || typeof parsedTheme !== 'object') {
      return null
    }

    return {
      navbar_color: parsedTheme.navbar_color,
      navbar_text_color: parsedTheme.navbar_text_color,
    }
  } catch (err) {
    return null
  }
}

if (typeof document !== 'undefined') {
  const storedTheme = getStoredOrganizationTheme()
  if (storedTheme) {
    applyOrganizationTheme(storedTheme)
  }
}


export function getMonth(month){
    const month_chart = {"01": "Jan",
                         "1": "Jan",
                         "02": "Feb",
                         "2": "Feb",
                         "03": "Mar",
                         "3": "Mar",
                         "04": "Apr",
                         "4": "Apr",
                         "05": "May",
                         "5": "May",
                         "06": "Jun",
                         "6": "Jun",
                         "07": "Jul",
                         "7": "Jul",
                         "08": "Aug",
                         "8": "Aug",
                         "09": "Sep",
                         "9": "Sep",
                         "10": "Oct",
                         "11": "Nov",
                         "12": "Dec"}

   return month_chart[month];
}

export function total0Recept(){
      var today = new Date
      var month = ("0" + (today.getMonth() + 1)).slice(-2)
      var date = ("0" + today.getDate()).slice(-2)
      var time = `${month}/${date}/${today.getFullYear()} ${today.getHours()}:${today.getMinutes()}`
      var response = {
          "ssl_card_number" : "************----",
          "ssl_oar_data" : "",
          "ssl_transaction_type" : "",
          "ssl_result" : "0",
          "ssl_txn_id" : "",
          "ssl_avs_response" : " ",
          "ssl_approval_code" : "",
          "ssl_amount" : "0",
          "ssl_txn_time" : time,
          "ssl_account_balance" : "0.00",
          "ssl_ps2000_data" : "",
          "ssl_exp_date" : "",
          "ssl_result_message" : "APPROVAL",
          "ssl_card_short_description" : "",
          "ssl_card_type" : "",
          "ssl_cvv2_response" : "",
        }
      return response
    }

export function seasonMap(month){
  const season = {
    1: 'winter',
    2: 'winter',
    3: 'winter',
    4: 'spring',
    5: 'spring',
    6: 'spring',
    7: 'summer',
    8: 'summer',
    9: 'summer',
    10: 'fall',
    11: 'fall',
    12: 'fall'
  }

  return season[month]
}

export function getSeasons(goToPast) {
  const currentYear = (new Date()).getFullYear()
  const currentMonth = (new Date()).getMonth() + 1
  const currentSeason = seasonMap(currentMonth)
  const options = []
  let year = currentYear, month = currentMonth, season = currentSeason;
  for (let i = 0; i < 8; i++) {
    options.push(`${season} ${year}`);
    month += goToPast ? -3 : 3;
    year = goToPast ?
      month < 1 ? year - 1 : year :
      month > 12 ? year + 1 : year;
    month = goToPast ?
      month < 1 ? 12 : month :
      month > 12 ? 1 : month;
    season = seasonMap(month);
  }
  return options
}

export function filter(originalList) {
  return originalList.filter((item) => {
    var searchWords = document.getElementsByName("filter")[0].value.toLowerCase().split(",");
    return searchWords.every((currentValue) => {
      return item.searchField.toLowerCase().indexOf(currentValue.toLowerCase()) !== -1;
    });
  });
}

export function filterSearch(originalList, search) {
  var searchWords = decodeURIComponent(search)
  searchWords = searchWords.toLowerCase().split(",")
  return originalList.filter((item) => {
    // searchable needs to be in the same order as the searchwords to find the program
    var searchable = " " + item.season + " " + item.ages + " " + item.division + " " + item.group_name + " " +
      item.type + " " + item.status + " " + item.start_date + " " + item.head_coach.first_name + " " +
      item.head_coach.last_name + " " +
      `${getMonth(item.start_date.slice(0,10).slice(5,7))} ${item.start_date.slice(0,10).slice(8,10)}, ${item.start_date.slice(0,10).slice(0,4)}`
      +" "+ item.status;
    return searchWords.every((currentValue) => {
      return searchable.toLowerCase().indexOf(currentValue.toLowerCase()) !== -1;
    });
  });
}

export const addStatus = (data) => {
  data.message.forEach(program => { program.status = getStatus(program) })
  return data
}

export const getStatus = (data) => {
  var year = (new Date()).getFullYear()
  var date = ('0' + (new Date()).getDate()).slice(-2)
  var month = ('0' + ((new Date()).getMonth() + 1)).slice(-2)
  var today = Date.now();

  console.log({sd: data.registration_start_date, ed: data.registration_end_date, today: today})
  const registration_start_date = moment(data.registration_start_date);
  const registration_end_date = moment(data.registration_end_date);
  const start_date = moment(data.start_date);
  const end_date = moment(data.end_date);
  const today_date = moment(today);

  if(data.registration_start_date === '1970-01-01T00:00:00.000Z' && data.registration_end_date === '1970-01-01T00:00:00.000Z' ) {
    return 'Cloned';
  }
  if(today_date.isSameOrAfter(start_date)){
    if(today_date.isAfter(end_date)){
      return 'Expired';
    }
    return 'Live';
  } else if (today_date.isAfter(registration_start_date)){
    if(today_date.isAfter(registration_end_date)){
      return 'Closed'
    } else if (data.status === 'waitlist'){
      return 'Waitlist Open'
    }
    return 'Open';
  }
  return 'Draft';
}

export const findPlanPrice = (program, plan_id) => {
  var temp 
  var plan = program.plans.find(p => { return p._id === plan_id })

  if (plan) {
    temp = plan.plan_price

    if (plan.membership_fee) {
      temp += plan.membership_fee
    }
    if (plan.extra_fees) {
      plan.extra_fees.forEach(fee => {
        for (var extra in fee) {
          temp += fee[extra]
        }
      })
    }
  }
  return temp
}

export const instalment_field = (instalments, instalment_number, selected_program, selected_plan, disabled, onInstalmentClick) => {
  var instalment_field = []
  var oneInstalmentAmount = findPlanPrice(selected_program, selected_plan)
  var tempInstalments = instalments.slice('')
  var first = tempInstalments.find(i => { return i.instalment_number === 1})
  if (!first) {
    tempInstalments.unshift({
      instalment_number: 1, 
      instalment_amount: oneInstalmentAmount
    })
  } else if (first && !first.instalment_amount) {
    first.instalment_amount = oneInstalmentAmount
  }

  instalment_field.push(
    <Row
     style={{marginLeft: "1%"}}>
      <Col sm={6}>
        {
          tempInstalments.map(i => {
            return (
              <Button value={i.instalment_number} onClick={(e) => onInstalmentClick(e)} className={instalment_number === i.instalment_number?"selected-installment-button" : "unselected-installment-button"} size="lg" disabled={disabled}>
                  {i.instalment_number === 1?"In Full":`${i.instalment_number} Payments`}
                <br/>
                ${i.instalment_amount}
              </Button>
            )
          })
        }
      </Col>
    </Row>
  )
  return instalment_field
}



export function makeOptions(udf) {
  var options = [<option key="-1" value="" disabled selected>Please select</option>]
  udf.type.values.forEach(value => {
    options.push(<option key={value} value={value}>{value}</option>)
  })
  return options
}

export function makeUniqueKey() {
  let characters = [1,2,3,4,5,6,7,8,9,0,"a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"]
  let key = ''
  for (let i = 0; i < 20; i++) {
    key = key + characters[Math.floor(Math.random() * Math.floor(characters.length))]
  }
  return key
}

export const generateNewShortLink = async (link, alias = '') => {
  let response = await axios.post(`${end_point("links")}/`,{
    doc: link,
    alias: slugifyLinkAlias(alias),
  })
  console.log('what is link response???', response)
  if(response.status === 200) {
    let data = response.data
    const aliasSlug = slugifyLinkAlias(alias)
    return `http://link.hoopstir.com/r/${data.code}${aliasSlug ? `?alias=${aliasSlug}` : ''}`
  } else {
    alert("There was an error creating short link.  Refresh page and try again.")
  }
}

export function handleApprovedRedirect(token) {
  window.location.href = document.location.origin + "/portals?jwt=" + token + "&protalMode=parent";
}

export const countryList = [
  <option value="" key="0" selected disabled>---</option>,
  <option value="Canada" key="can">Canada</option>,
  <option value="United States" key="usa">United States</option>,
  <option value="Hong Kong" key="hk">Hong Kong</option>,
]

export const CAprovinces = [
  <option value="" key="0" selected disabled>---</option>,
  <option value="ON" key="ON">Ontario</option>,
  <option value="QC" key="QC">Quebec</option>,
  <option value="NS" key="NS">Nova Scotia</option>,
  <option value="NB" key="NB">New Brunswick</option>,
  <option value="MB" key="MB">Manitoba</option>,
  <option value="BC" key="BC">British Columbia</option>,
  <option value="PE" key="PE">Saskatchewan</option>,
  <option value="AB" key="AB">Alberta</option>,
  <option value="NL" key="NL">Newfoundland/Labrador</option>,
]

export const USstates = [
  <option value="" key="0" selected disabled>---</option>,
  <option value="AL" key="AL">Alabama</option>,
  <option value="AK" key="AK">Alaska</option>,
  <option value="AZ" key="AZ">Arizona</option>,
  <option value="AR" key="AR">Arkansas</option>,
  <option value="CA" key="CA">California</option>,
  <option value="CO" key="CO">Colorado</option>,
  <option value="CT" key="CT">Connecticut</option>,
  <option value="DE" key="De">Delaware</option>,
  <option value="FL" key="FL">Florida</option>,
  <option value="GA" key="GA">Georgia</option>,
  <option value="HI" key="HI">Hawaii</option>,
  <option value="ID" key="ID">Idaho</option>,
  <option value="IL" key="IL">Illinois</option>,
  <option value="IN" key="IN">Indiana</option>,
  <option value="IA" key="IA">Iowa</option>,
  <option value="KS" key="KS">Kansas</option>,
  <option value="KY" key="KY">Kentucky</option>,
  <option value="LA" key="LA">Louisiana</option>,
  <option value="ME" key="ME">Maine</option>,
  <option value="MD" key="MD">Maryland</option>,
  <option value="MA" key="MA">Massachusetts</option>,
  <option value="MI" key="MI">Michigan</option>,
  <option value="MN" key="MN">Minnesota</option>,
  <option value="MS" key="MS">Mississippi</option>,
  <option value="MO" key="MO">Missouri</option>,
  <option value="MT" key="MT">Montana</option>,
  <option value="NE" key="NE">Nebraska</option>,
  <option value="NV" key="NV">Nevada</option>,
  <option value="NH" key="NH">New Hampshire</option>,
  <option value="NJ" key="NJ">New Jersey</option>,
  <option value="NM" key="NM">New Mexico</option>,
  <option value="NY" key="NY">New York</option>,
  <option value="NC" key="NC">North Carolina</option>,
  <option value="ND" key="ND">North Dakota</option>,
  <option value="OH" key="OH">Ohio</option>,
  <option value="OK" key="OK">Oklahoma</option>,
  <option value="OR" key="OR">Oregon</option>,
  <option value="PA" key="PA">Pennsylvania</option>,
  <option value="RI" key="RI">Rhode Island</option>,
  <option value="SC" key="SC">South Carolina</option>,
  <option value="SD" key="SD">South Dakota</option>,
  <option value="TN" key="TN">Tennessee</option>,
  <option value="TX" key="TX">Texas</option>,
  <option value="UT" key="UT">Utah</option>,
  <option value="VT" key="VT">Vermont</option>,
  <option value="VA" key="VA">Virginia</option>,
  <option value="WA" key="WA">Washington</option>,
  <option value="WV" key="WV">West Virginia</option>,
  <option value="WI" key="WI">Wisconsin</option>,
  <option value="WY" key="WY">Wyoming</option>,
]

export const HKprovinces = [
  <option value="" key="0" selected disabled>---</option>,
  <option value="CW" key="CW">Central and Western /	中西區</option>,
  <option value="EN" key="EN">Eastern /	東區</option>,
  <option value="SN" key="SN">Southern / 南區</option>,
  <option value="WC" key="WC">Wan Chai / 灣仔區</option>,
  <option value="SSP" key="SSP">Sham Shui Po / 深水埗區</option>,
  <option value="KC" key="KC">Kowloon City / 九龍城區</option>,
  <option value="KT" key="KT">Kwun Tong /	觀塘區</option>,
  <option value="WTS" key="WTS">Wong Tai Sin / 黃大仙區</option>,
  <option value="YTM" key="YTM">Yau Tsim Mong /	油尖旺區</option>,
  <option value="ID" key="ID">Islands /	離島區</option>,
  <option value="KTS" key="KTS">Kwai Tsing / 葵青區</option>,
  <option value="NH" key="NH">North /	北區</option>,
  <option value="SK" key="SK">Sai Kung / 西貢區</option>,
  <option value="ST" key="ST">Sha Tin / 沙田區</option>,
  <option value="TP" key="TP">Tai Po / 大埔區</option>,
  <option value="TW" key="TW">Tsuen Wan / 荃灣區</option>,
  <option value="TM" key="TM">Tuen Mun / 屯門區</option>,
  <option value="YL" key="YL">Yuen Long / 元朗區</option>,
]

export const genderOptions = [
  <option value="" key="0" selected disabled>---</option>,
  <option value="male" key="male">Male</option>,
  <option value="female" key="female">Female</option>,
  <option value="prefer_not_to_say" key="PNTS">Prefer Not To Say</option>,
]

export const daysOfWeek = [
  <option key='-1' value="select">DOW</option>,
  <option key='0' value="Monday">Monday</option>,
  <option key='1' value="Tuesday">Tuesday</option>,
  <option key='2' value="Wednesday" >Wednesday</option>,
  <option key='3' value="Thursday">Thursday</option>,
  <option key='4' value="Friday">Friday</option>,
  <option key='5' value="Saturday">Saturday</option>,
  <option key='6' value="Sunday">Sunday</option>,
  <option key='7' value="Weekdays">Weekdays</option>,
  <option key='8' value="Weekends">Weekends</option>,
]

export const formatSessionDateLabel = (session) => {
  if (!session) {
    return ''
  }

  if (session.date) {
    const sessionDate = moment(session.date)
    if (sessionDate.isValid()) {
      return sessionDate.format('MMM D, YYYY')
    }
  }

  return session.day || ''
}

export const sortProgramSessions = (sessions = []) => (
  sessions.slice().sort((left, right) => {
    const leftDate = left && left.date ? moment(left.date) : null
    const rightDate = right && right.date ? moment(right.date) : null

    if (leftDate && rightDate && leftDate.isValid() && rightDate.isValid()) {
      const dateDelta = leftDate.valueOf() - rightDate.valueOf()
      if (dateDelta !== 0) {
        return dateDelta
      }
    } else if (leftDate && leftDate.isValid()) {
      return -1
    } else if (rightDate && rightDate.isValid()) {
      return 1
    }

    const leftStart = left && left.start_time ? moment(left.start_time, ['hh:mm A', 'h:mm A', 'HH:mm']) : null
    const rightStart = right && right.start_time ? moment(right.start_time, ['hh:mm A', 'h:mm A', 'HH:mm']) : null

    if (leftStart && rightStart && leftStart.isValid() && rightStart.isValid()) {
      return leftStart.valueOf() - rightStart.valueOf()
    }

    return 0
  })
)

export const program_type = [
  <option key={makeUniqueKey()} value="" selected disabled>---</option>,
  <option key="camp" value="camp">Camp</option>,
  <option key="academy" value="academy">Academy</option>,
  <option key="class" value="class">Class</option>,
  <option key="club team" value="club team">Club Team</option>,
  <option key="house league" value="house league">House League</option>,
  <option key="open gym" value="open gym">Open Gym</option>,
  <option key="showcase" value="showcase">Showcase</option>,
  <option key="virtual training" value="virtual training">Virtual Training</option>,
]

export const program_types = ['camp', 'academy', 'class', 'club team', 'house league', 'open gym', 'showcase']

export const extLeague_types = ['tournament', 'rep league']

export const capitalize = word => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const cloneLeague_type = [
  <option key={makeUniqueKey()} value="" selected disabled>---</option>,
  <option key="tournament teams" value="tournament teams">Tournament Team</option>,
  <option key="rep league teams" value="rep league teams">Rep League Team</option>
]

export const extLeague_type = [
  <option key={makeUniqueKey()} value="" selected disabled>---</option>,
  <option key="tournament" value="tournament">Tournament</option>,
  <option key="rep league" value="rep league">Rep League</option>
]

export const divisionOptions = [
  <option key={makeUniqueKey()} value="" selected disabled>---</option>,
  <option key={makeUniqueKey()} value="co-ed">Co-Ed</option>,
  <option key={makeUniqueKey()} value="girls">Girls</option>,
  <option key={makeUniqueKey()} value="boys">Boys</option>,
]

// -------- FOR VIDEO BROADCAST --------

export function onStatsReport(report) {
  // TODO: Publish stats
}
